import { rwd, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

const SIDE_PANEL_WIDTH = '362px'

export const ImportedInvoiceDrawerColumnsWrapper = styled.div`
  display: grid;
  flex: 1;
  gap: ${Spacing.S24};
  grid-template-columns: minmax(0, 1fr) ${SIDE_PANEL_WIDTH};
  min-height: 0;

  ${rwd.equalOrLessThan('medium')} {
    grid-template-columns: minmax(0, 1fr);
  }
`
